import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, Mail } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

import { LOGO_IMAGE as LOGO_URL } from "../../lib/siteImages";

const AdminLogin = () => {
  const { admin, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (admin) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Identifiants incorrects");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-6">
          <img src={LOGO_URL} alt="Noctua" width="64" height="64" className="h-16" data-testid="admin-login-logo" />
        </div>
        <p className="eyebrow text-center mb-3">Espace admin</p>
        <h1 className="font-display text-4xl text-center text-white mb-2 leading-none">
          Connexion <span className="italic text-gold">admin</span>
        </h1>
        <div className="gold-line w-16 mx-auto my-6" />

        <form onSubmit={handleSubmit} className="bg-night-2 border border-subtle p-8 space-y-6" data-testid="admin-login-form">
          <div>
            <label className="text-xs text-gray-500 uppercase tracking-wider flex items-center gap-2 mb-1">
              <Mail size={12} /> Email
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="input-line"
              placeholder="admin@noctua.fr"
            />
          </div>
          <div>
            <label className="text-xs text-gray-500 uppercase tracking-wider flex items-center gap-2 mb-1">
              <Lock size={12} /> Mot de passe
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="input-line"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div className="border border-red-500/40 bg-red-500/10 text-red-300 px-3 py-2 text-sm" data-testid="admin-login-error">
              {error}
            </div>
          )}

          <button type="submit" disabled={submitting} className="btn-gold w-full" data-testid="admin-login-submit">
            {submitting ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
